// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__13wcS","title-container":"style_title-container__OeXyY","title":"style_title__6tl9y","subtitle":"style_subtitle__2RIVn","icon":"style_icon__1XNAC"};